



































import { openModal, HasTaskMixin, notify } from 'mycorems-app-shared';
import recognition from '../auth/recognition';
import { User } from '../types';
import EditUserModal from './EditUserModal.vue';
import ChangePasswordModal from '../auth/ChangePasswordModal.vue';
import DeleteUserConfirmationModal from './DeleteUserConfirmationModal.vue';

export default HasTaskMixin.extend({
  props: {
    user: {
      type: Object as () => User,
      required: true,
    },
  },
  computed: {
    canDelete(): boolean {
      return (this.user.id !== recognition.getUserId());
    },
  },
  methods: {
    editProfile(): void {
      openModal(EditUserModal, {
        user: this.user,
      }).onOk((user: User) => {
        this.$emit('user-edited', user);
      });
    },
    updatePassword(): void {
      openModal(ChangePasswordModal, {
        userId: this.user.id,
      });
    },
    deleteUserProfile(): void {
      openModal(DeleteUserConfirmationModal, {
        id: this.user.id,
      }).onOk(() => {
        this.$router.push(`/accounts/accounts/${this.user.accountId}`);
      });
    },
  },
});
